var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p'),_c('h2',[_vm._v(" 这里查看 按日的留存信息 dailyRetention ")]),_c('h2',[_vm._v(" 这里查看 按日的留存信息 dailyRetention 先临时放一下, 后续会做成 直接兼容 刷新 或者直接展示\"; ")]),_c('p')])
}]

export { render, staticRenderFns }